import { render, staticRenderFns } from "./r-map-group-page.vue?vue&type=template&id=94960e36&scoped=true&class=map-group-page"
import script from "./r-map-group-page.vue?vue&type=script&lang=js"
export * from "./r-map-group-page.vue?vue&type=script&lang=js"
import style0 from "./r-map-group-page.vue?vue&type=style&index=0&id=94960e36&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94960e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94960e36')) {
      api.createRecord('94960e36', component.options)
    } else {
      api.reload('94960e36', component.options)
    }
    module.hot.accept("./r-map-group-page.vue?vue&type=template&id=94960e36&scoped=true&class=map-group-page", function () {
      api.rerender('94960e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-group/r-map-group-page.vue"
export default component.exports